import type Rollbar from 'rollbar';

const FIRESTORE_INTERNAL_ASSERTION_LOG_MESSAGE =
  'Firestore client internal assertion failed';

const FIRESTORE_INTERNAL_ASSERTION_FINGERPRINT = 'firestore-internal-assertion';

function isFirestoreInternalAssertionMessage(message: string): boolean {
  const normalized = message.toUpperCase();
  return (
    normalized.includes('FIRESTORE') &&
    normalized.includes('INTERNAL ASSERTION FAILED')
  );
}

function getRollbarPayloadMessage(payload: Rollbar.Dictionary): string {
  const body = payload.body as Rollbar.Dictionary | undefined;
  if (!body) {
    return '';
  }

  const trace = body.trace as Rollbar.Dictionary | undefined;
  const exception = trace?.exception as Rollbar.Dictionary | undefined;
  if (typeof exception?.message === 'string') {
    return exception.message;
  }
  if (typeof body.message === 'string') {
    return body.message;
  }
  return '';
}

/** Normalizes noisy Firestore SDK assertion errors so Rollbar groups them under one title. */
function firestoreRollbarTransform(payload: Rollbar.Dictionary): void {
  const originalMessage = getRollbarPayloadMessage(payload);
  if (!isFirestoreInternalAssertionMessage(originalMessage)) {
    return;
  }

  const body = (payload.body ?? {}) as Rollbar.Dictionary;
  payload.body = body;

  body.message = FIRESTORE_INTERNAL_ASSERTION_LOG_MESSAGE;
  body.fingerprint = FIRESTORE_INTERNAL_ASSERTION_FINGERPRINT;

  const trace = (body.trace ?? {}) as Rollbar.Dictionary;
  body.trace = trace;

  const exception = (trace.exception ?? {}) as Rollbar.Dictionary;
  trace.exception = exception;
  exception.message = FIRESTORE_INTERNAL_ASSERTION_LOG_MESSAGE;
  exception.description = originalMessage;

  const custom = (body.custom ?? {}) as Rollbar.Dictionary;
  body.custom = {
    ...custom,
    firestoreErrorType: 'internal_assertion',
    originalErrorMessage: originalMessage,
  };
}

export {
  FIRESTORE_INTERNAL_ASSERTION_FINGERPRINT,
  FIRESTORE_INTERNAL_ASSERTION_LOG_MESSAGE,
  firestoreRollbarTransform,
  isFirestoreInternalAssertionMessage,
};
